import { Styles, ViewStyle } from '@bonanza-social/moonlight';

export enum OnboardingStep {
  statuses = 'statuses',
  playNEarn = 'playNEarn',
  keepProgressing = 'keepProgressing',
  gettingBetter = 'gettingBetter',
}

export type StatusOnboardingProps = Styles<ViewStyle> & {
  onInitialAnimationFinished?: () => void;
};
